<template>
  <div class="my-order" ref="container">
    <nav-bar
        fixed
        z-index="99"
        title="全部订单"
        left-text="返回"
        left-arrow
        @click-left="$router.push({
        path: '/user',
       })"
    />
    <!-- 自定义提示框 -->
    <div class="custom-toast" v-show="showToast">
      {{ toastMessage }}
    </div>
    <div style="height: 46px"></div>
    <!-- 修改订单状态过滤器为下拉框形式 -->
    <div class="order-filter">
      <div class="dropdown-filter" style="text-align:center">
        <div class="selected-filter" @click="toggleDropdown">
          点击按状态搜索： {{ filterItems[activeFilterIndex].text }} <i class="arrow" :class="{ 'arrow-up': showDropdown }"></i>
        </div>
        <div class="dropdown-menu" v-show="showDropdown">
          <div
              v-for="(item, index) in filterItems"
              :key="index"
              class="dropdown-item"
              :class="{ active: activeFilterIndex === index }"
              @click="filterOrders(index)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div
          class="item"
          style="position: relative; overflow: hidden"
          v-for="order in filteredOrderList"
          :key="order.id"
      >
        <span class="order-status">{{
            order.refundStatus === 1
                ? "售后中"
                : order.refundStatus === 2
                    ? "已退款"
                    : statusText[order.status]
          }}</span>
        <div>
          <div class="order-top">
            订单号：{{ order.orderId }}
            <i class="van-icon van-icon-description copy-icon" @click.stop="copyOrderLink(order.orderId,2)" title="复制订单链接"></i>
          </div>
          <div v-if="userCategory == 2" class="order-link-btn" @click.stop="copyOrderLink(order.orderId,1)">
            复制订单链接
          </div>
          <div
              class="item-info"
              @click="
              $router.push({
                path: '/order/detail/' + order.orderId,
                query: { userCategory },
              })
            "
              v-if="userCategory == 2"
          >
            <div class="acea-row row-between row-top" v-if="order.lcUser">
              <div class="pictrue">
                <img
                    :src="order.lcUser.avatar"
                    @click.stop="
                    $router.push({
                      path: '/detail/' + order.cartInfo[0].productInfo.id,
                    })
                  "
                />
              </div>
              <div class="text">
                <div class="name">
                  {{ order.lcUser.nickname || "名字C" }}
                </div>
                <div class="line1">
                  {{ order.lcUser.phone }}
                </div>
                <div class="line1">
                  {{ order.createTime }}
                </div>
              </div>
            </div>
            <div class="message line2">{{ order.remark }}</div>
          </div>
          <div
              class="item-info"
              @click="
              $router.push({
                path: '/order/detail/' + order.orderId,
                query: { userCategory },
              })
            "
              v-else
          >
            <div class="acea-row row-between row-top">
              <div class="pictrue">
                <img
                    :src="order.cartInfo[0].productInfo.image"
                    @click.stop="
                    $router.push({
                      path: '/detail/' + order.cartInfo[0].productInfo.id,
                    })
                  "
                />
              </div>
              <div class="text">
                <div class="name">
                  {{ order.cartInfo[0].productInfo.storeName || "名字D" }}
                </div>
                <div class="line1">
                  {{ order.cartInfo[0].productInfo.storeInfo }}
                </div>
                <div class="line1">
                  {{ order.createTime }}
                </div>
              </div>
            </div>
            <div class="message line2">
              {{ order.cartInfo[0].productInfo.practiceExperience }}
            </div>
          </div>
        </div>
        <div
            style="
            text-align: left;
            color: #ff1200;
            padding: 0 0.2rem 0.1rem 0.2rem;
          "
            v-if="
            order.status == 0 && userCategory == 1 && order.refundStatus != 1
          "
        >
          {{ order._status._msg }}
        </div>
        <div
            style="
            text-align: left;
            color: #ff1200;
            padding: 0 0.2rem 0.1rem 0.2rem;
          "
            v-if="order.refundStatus == 1 && userCategory == 1"
        >
          退款申请已成功提交审核，平台审核时效为3个工作日
        </div>
        <div
            style="
            text-align: left;
            color: #ff1200;
            padding: 0 0.2rem 0.1rem 0.2rem;
          "
            v-if="order.status == 2 && !order.refundStatus && userCategory == 2"
        >
          您已确认接单，请尽快联系客户，并根据双方达成一致的预约时间进行教练约谈。
        </div>
        <div class="bottom acea-row row-middle row-between">
          <div class="totalPrice" style="white-space: nowrap; font-size: 90%;">
            ￥{{ order.payPrice }}
            <!-- (order.status == 2 || order.status == 3 || order.status == 7) -->
            <span v-if="userCategory == 2" class="commission">教练分成:￥{{ order.giveawayAmount || 0 }}</span>
          </div>
          <div class="acea-row">
            <template v-if="order.status == 0 && !order.refundStatus">
              <div
                  class="bnt cancelBnt"
                  @click="cancelOrder(order)"
                  v-if="userCategory == 1"
              >
                取消订单
              </div>
              <div
                  class="bnt bg-color-theme"
                  @click="paymentTap(order)"
                  v-if="userCategory == 1"
              >
                立即付款
              </div>

            </template>
            <template v-if="order.refundStatus === 2">
              <div class="refund-actions">
                <div
                    @click="
                    $router.push({
                      path: '/order/detail/' + order.orderId,
                      query: { userCategory },
                    })
                  "
                >
                  <!-- {{ order._status._title }}已退款 -->
                </div>
              </div>
            </template>
            <template v-if="order.status == 1 && !order.refundStatus">
              <div
                  v-if="userCategory == 2 && order.auditStatus === 1"
                  class="bnt btn-disabled"
                  @click.stop="showAuditPendingMessage()"
              >
                来源审核中
              </div>
              <div
                  v-else-if="userCategory == 2"
                  class="bnt bg-color-theme"
                  @click.stop="submitOrder(order)"
              >
                确认接单
              </div>
            </template>
            <template v-if="order.status == 7 && !order.refundStatus">
              <div
                  class="bnt bg-color-theme"
                  @click="finishOrder(order)"
                  v-if="userCategory == 1"
              >
                <!-- 首约和单次 -->
                <span v-if="order.firstOrder == 1 || isSingle(order)"
                >订单确认完成</span
                >
                <span v-else>确认继续旅程</span>
              </div>
            </template>
            <template v-if="order.status === 2 && !order.refundStatus">
              <div
                  class="bnt bg-color-theme"
                  @click="coachOrder(order)"
                  v-if="userCategory == 2"
              >
                <!-- 首约和单次 -->
                <span v-if="order.firstOrder == 1 || isSingle(order)"
                >订单确认完成</span
                >
                <span v-else>确认继续旅程</span>
              </div>

            </template>
            <template v-if="order.status == 3 && !order.refundStatus && userCategory == 2">
              <div
                  class="bnt"
                  style="background-color: #FF9500; color: #fff;"
                  @click="inviteEvaluation(order)"
              >
                邀请评价
              </div>
            </template>

            <template v-if="order.status == 3 && !order.refundStatus && userCategory == 1">
              <div
                  class="bnt bg-color-theme"
                  @click="goToEvaluate(order)"
                  v-if="userCategory == 1"
              >
                去评价
              </div>
              <div
                  class="bnt bg-color-theme"
                  v-if="userCategory == 1"
                  @click.stop="dialogTo(order, 'showDialog')"
              >
                续约
              </div>

            </template>
            <template
                v-if="
                (order.status === 4 || order.status == 5) && !order.refundStatus
              "
            >
              <div
                  class="bnt bg-color-theme"
                  v-if="userCategory == 1"
                  @click.stop="dialogTo(order, 'showDialog')"
              >
                续约
              </div>
              <div
                  class="bnt bg-color-theme"
                  v-if="order.productReplyList && order.productReplyList.length"
                  @click="
                  $router.push({
                    path: '/order/order_evaluate/' + order.orderId,
                    query: { userCategory },
                  })
                "
              >
                查看评价
              </div>

            </template>
            <template v-if="order.status == 5 && !order.refundStatus">
              <div
                  class="bnt delete-btn"
                  @click="deleteOrder(order, userCategory)"
                  v-if="userCategory == 1"
              >
                删除
              </div>
              <div
                  class="bnt delete-btn"
                  @click="deleteOrder(order,userCategory)"
                  v-if="userCategory == 2"
              >
                删除
              </div>
            </template>
            <div class="bnt bg-color-theme"
                 @click="
                  $router.push({
                    path: '/order/detail/' + order.orderId,
                    query: { userCategory },
                  })
                "
            >
              查看详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/img/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
        v-model="pay"
        :types="payType"
        @checked="toPay"
        :balance="userInfo.nowMoney"
    ></Payment>
    <Popup v-model="showDialog" round>
      <div class="agree-title">{{ articleInfo.title }}</div>
      <div class="agree-content">
        <div v-html="articleInfo.content"></div>
      </div>
      <div class="agree-btn" @click="toXuyue()">确认</div>
    </Popup>
    <Popup v-model="showDialog1" round>
      <div class="agree-title">{{ articleInfo1.title }}</div>
      <div class="agree-content">
        <div v-html="articleInfo1.content"></div>
      </div>
      <div class="agree-btn" @click="submitOrder(order)">确认</div>
    </Popup>
    <van-dialog
        v-model="showSourceDialog"
        title=""
        :show-confirm-button="false"
        :close-on-click-overlay="false"
        class="source-select-dialog"
    >
      <div class="source-select-container" @click.stop>
        <div class="close-icon source-dialog-close" @click.stop="showSourceDialog = false">
          <i class="van-icon van-icon-cross"></i>
        </div>
        <div class="source-select-header">订单来源选择</div>
        <div class="domain-tabs">
          <div
              class="domain-tab"
              :class="{ active: selectedDomain === 'private' }"
              @click="switchDomain('private')"
          >
            私域
          </div>
          <div
              class="domain-tab"
              :class="{ active: selectedDomain === 'public' }"
              @click="switchDomain('public')"
          >
            公域
          </div>
        </div>

        <div class="source-options">
          <div
              v-for="option in sourceOptions"
              :key="option.id"
              class="source-option"
              :class="{
              selected: selectedSources.some(s => s.id === option.id),
              disabled: hasOtherSelected &&(option.value !== '3' && option.value !== '6')
            }"
              @click="toggleSource(option, $event)"
          >
            <div class="source-checkbox">
              <div class="checkbox-inner" v-if="selectedSources.some(s => s.id === option.id)"></div>
            </div>
            <div class="source-label">{{ option.label }}</div>
          </div>

          <!-- 备注输入框 - 仅当"其他[3]"、"教练认证班学员推荐的客户[6]"选项被选中时显示 -->
          <div class="remark-input" v-if="hasOtherSelected">
            <input
                type="text"
                v-model="sourceRemark"
                placeholder="请输入内容"
                @click.stop
            />
          </div>

          <div class="instruction-content" v-html="orderSourceDescription"></div>
        </div>

        <div class="confirm-button" @click.stop="confirmSourceSelection">
          确认来源
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { getOrderList, setOrderRead, delClient } from "@api/order";
import { getViewDetails } from "@api/public";
import { getDict } from "@api/admin";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle,
} from "@libs/order";
import {
  submitOrderHandle,
  coachConfirmSource,
  finishOrderHandle,
  coachOrderHandle,
  inviteEvaluation,
} from "@api/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin, dataFormat } from "@utils";
import { NavBar, Popup, Dialog } from "vant";
import request from "@utils/request";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已确认",
  "",
  "",
  "",
  "",
  "待付款",
];

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 10,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      statusText: {
        0: "待支付",
        1: "待确认",
        2: "进行中",
        3: "待评价",
        4: "旅程已确认",
        5: "已取消",
        6: "售后",
        7: this.$route.query.userCategory == 1 ? "待确认旅程" : "待客户确认旅程",
      },
      showDropdown: false, // 控制下拉框显示
      // 修改为空数组，将在计算属性中动态生成
      activeFilterIndex: parseInt(this.$route.query.filterIndex) || 0,
      filterItems: [],
      articleInfo: {},
      id: "",
      showDialog: false,
      showDialog1: false,
      articleInfo1: {},
      order: {},
      // 当前用户是已什么身份查看当前页面信息的,默认为用户
      userCategory: this.$route.query.userCategory || 1,
      selectedDomain: 'public',
      currentOrder: null,
      selectedSources: [],
      defaultOrderSource: null, // 新增：存储订单的默认来源
      sourceOptions: [], // 来源选项
      showSourceDialog: false, // 来源选择对话框
      sourceRemark: "", // 新增：来源备注
      hasOtherSelected: false,
      orderSourceDescription: "", // 新增：订单来源说明
      baseUrl: "https://m.lcwlit.com", // 默认值，将通过系统配置动态更新
      showToast: false, // 控制提示框显示
      toastMessage: '', // 提示消息内容
      isSubmitting: false, // 防抖标志
    };
  },
  components: {
    Loading,
    Payment,
    NavBar,
    Popup,
    VanDialog: Dialog.Component,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 动态生成filterItems
    dynamicFilterItems() {
      // 基础过滤项，所有用户都可见
      const baseItems = [
        { text: "全部订单", status: null, refundStatus: null },
        { text: "待支付", status: 0, refundStatus: null },
        { text: "待确认", status: 1, refundStatus: null },
        { text: "进行中", status: 2, refundStatus: null },
        { text: "待评价", status: 3, refundStatus: null },
        { text: "旅程已确认", status: 4, refundStatus: null },
        { text: "已取消", status: 5, refundStatus: null },
        { text: "售后中", status: null, refundStatus: 1 },
        { text: "已退款", status: null, refundStatus: 2 }
      ];

      // 如果是教练用户，添加"待客户确认旅程"选项
      if (this.userCategory == 2) {
        // 在进行中和待评价之间插入
        baseItems.splice(4, 0, { text: "待客户确认旅程", status: 7, refundStatus: null });
      }

      return baseItems;
    },
    // 新增计算属性：根据过滤条件过滤订单
    filteredOrderList() {
      if (this.activeFilterIndex === 0) {
        return this.orderList; // 返回全部订单
      }

      const filter = this.filterItems[this.activeFilterIndex];

      return this.orderList.filter(order => {
        // 根据 refundStatus 过滤
        if (filter.refundStatus !== null) {
          return order.refundStatus === filter.refundStatus;
        }

        // 根据 status 过滤
        if (filter.status !== null) {
          return order.status === filter.status && !order.refundStatus;
        }

        return false;
      });
    }
  },
  watch: {
    // 添加监听dynamicFilterItems的变化
    dynamicFilterItems: {
      immediate: true,
      handler(newItems) {
        this.filterItems = newItems;

        // 如果当前选中的过滤索引超出了可用过滤项的范围，重置为0（全部订单）
        if (this.activeFilterIndex >= newItems.length) {
          this.activeFilterIndex = 0;
        }
      }
    },
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 10;
        if (this.type !== type) {
          this.changeType(type);
        }

        // 从路由查询参数恢复筛选状态
        if (n.query.filterIndex !== undefined) {
          this.activeFilterIndex = parseInt(n.query.filterIndex);
        }
      }
    },
  },
  methods: {
    dataFormat,
    // 切换下拉菜单显示/隐藏
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    // 点击空白区域关闭下拉菜单
    closeDropdown(e) {
      // 如果点击的不是下拉菜单区域，则关闭下拉菜单
      if (!this.$el.querySelector('.dropdown-filter').contains(e.target)) {
        this.showDropdown = false;
      }
    },
    // 修改过滤订单方法，保存筛选状态到路由查询参数
    filterOrders(index) {
      this.activeFilterIndex = index;
      this.showDropdown = false; // 选择后关闭下拉菜单

      // 将筛选状态添加到路由查询参数中
      const query = { ...this.$route.query, filterIndex: index };

      // 使用 replace 而不是 push，避免产生多余的历史记录
      this.$router.replace({
        path: this.$route.path,
        query: query
      });

      // 如果过滤后没有数据且不是第一页，重新加载第一页
      if (this.filteredOrderList.length === 0 && this.page > 1) {
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
        this.getOrderList();
      }
    },
    // 新增：将UI/订单数据中的来源值映射到API所需的来源值
    // UI/订单数据 selectedSource: 1 = 私域, 2 = 公域
    // 后端 API confirmOrderSource: 1 = 私域, 2 = 公域
    mapUiSourceToApiSource(uiSource) {
      if (uiSource === 1) { // UI 选择 1 (私域)
        return 1; // API 值 1 (私域)
      }
      if (uiSource === 2) { // UI 选择 2 (公域)
        return 2; // API 值 2 (公域)
      }
      return null;
    },
    getAgree: function () {
      getViewDetails(48).then((res) => {
        this.articleInfo = res.data;
      });
      getViewDetails(51).then((res) => {
        this.articleInfo1 = res.data;
      });
    },
    dialogTo(order, type) {
      this[type] = true;
      this.order = order;
    },
    // 将订单标记为已读
    setOrderRead(order) {
      const data = {
        // 客户0 用户1
        type: this.$route.query.userCategory == 1 ? 1 : 0,
      };
      setOrderRead(data).then(() => {});
    },
    toXuyue() {
      this.$router.push({
        path: `/order/submit/${this.order.cartInfo[0].productInfo.id}`,
        query: { type: 1 },
      });
    },
    setOfflinePayStatus: function (status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    takeOrder(order) {
      takeOrderHandle(order.orderId).finally(() => {
        this.reload();
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      //this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;

      if (this.$route.query.orderId === "") {
        this.$dialog.message("该订单号为空");
        this.loading = false;
        return;
      }
      //调用查询方法
      getOrderList({
        page,
        limit,
        type,
        userCategory: this.$route.query.userCategory || 1,
        orderId: this.$route.query.orderId,
      }).then((res) => {
        this.orderList = this.orderList.concat(res.data);
        //后台打印orderList
        console.log("orderList", this.orderList);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
        if (page == 1) {
          const l = res.data.filter((item) => {
            return this.userCategory === 2
                ? !item.isRefresh
                : !item.isUserRefresh;
          });
          this.$store.commit("SET_REFRESH_NUM", l.length);
        }
      });
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder(order) {
      cancelOrderHandle(order.orderId)
          .then(() => {
            // 取消订单成功后刷新订单列表
            this.changeType(this.type);
          })
          .catch(() => {
            this.reload();
          });
    },
    paymentTap: function (order) {
      payOrderHandle(order.orderId, "weixin", this.from)
          .then(() => {
            this.changeType(1);
          })
          .catch(() => {
            const type = parseInt(this.$route.params.type) || 0;
            this.changeType(type);
          });
    },
    toPay() {},

    isSingle(order) {
      // this.orderInfo.cartInfo[0].productAttrUnique == ''
      if (
          order.cartInfo &&
          Array.isArray(order.cartInfo) &&
          order.cartInfo.length > 0
      ) {
        const cartInfo = order.cartInfo[0];
        // 单次
        if (cartInfo.productAttrUnique == "") return true;
        if (!cartInfo.productInfo.attrInfo) return false;
        // 续约单次
        return cartInfo.productInfo.attrInfo.sku == 1;
      }
      return false;
    },
    submitOrder(order) {
      if (this.isSubmitting) return;

      this.showDialog1 = false;
      this.currentOrder = order;

      // 如果是公益订单(welfareOrder=1)，则直接确认订单，不需要确认来源
      if (order.welfareOrder === 1) {
        this.isSubmitting = true;
        this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
        submitOrderHandle({ uni: order.orderId })
            .then(() => {
              this.$toast.success("订单已确认");
              this.changeType(2);
            })
            .catch(err => {
              this.$toast.fail(err.msg || "订单确认失败");
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        return;
      }

      // 如果是首单(firstOrder=1)，则直接确认订单，不需要确认来源
      // if (order.firstOrder === 1) {
      //   submitOrderHandle({ uni: order.orderId })
      //       .then(() => {
      //         this.$toast.success("订单已确认");
      //         this.changeType(2);
      //       })
      //       .catch(err => {
      //         this.$toast.fail(err.msg || "订单确认失败");
      //       });
      //   return;
      // }

      // ---- 订单审核状态检查 ----
      if (order.auditStatus === 1) {
        this.$toast.info("您选择的订单来源正在审核中，请耐心等待。");
        return;
      }

      if (order.auditStatus === 2) {
        // 审核已通过，直接使用 order.confirmOrderSource
        if (order.confirmOrderSource === 1 || order.confirmOrderSource === 2) {
          this.$dialog.confirm({
            mes: "订单来源已由管理员审核通过，是否直接确认订单？",
            opts: () => {
              if (this.isSubmitting) return;
              this.isSubmitting = true;
              this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
              submitOrderHandle({
                uni: order.orderId,
                confirmOrderSource: order.confirmOrderSource
              })
                  .then(() => {
                    this.$toast.success("订单已确认");
                    this.changeType(2);
                  })
                  .catch(err => {
                    this.$toast.fail(err.msg || "订单确认失败");
                  })
                  .finally(() => {
                    this.isSubmitting = false;
                  });
            }
          });
        } else {
          this.$toast.fail("审核已通过，但订单来源信息不明确，请联系技术支持。");
        }
        return;
      }

      // ---- 已有confirmOrderSource的处理 ----
      if (order.confirmOrderSource === 1 || order.confirmOrderSource === 2) {
        const apiConfirmedSource = order.confirmOrderSource;

        this.$dialog.confirm({
          mes: "订单来源已指定，是否直接确认订单？",
          opts: () => {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
            submitOrderHandle({
              uni: order.orderId,
              confirmOrderSource: apiConfirmedSource
            })
                .then(() => {
                  this.$toast.success("订单已确认");
                  this.changeType(2);
                })
                .catch(err => {
                  this.$toast.fail(err.msg || "订单确认失败");
                })
                .finally(() => {
                  this.isSubmitting = false;
                });
          }
        });
        return;
      }

      // ---- 显示来源选择对话框 ----
      this.selectedSources = [];
      this.hasOtherSelected = false;
      this.sourceRemark = "";

      // 根据订单的source字段设置默认的域类型
      // source: 1 = 私域, 2 = 公域
      this.selectedDomain = order.source === 1 ? 'private' : 'public';

      // 先加载对应域类型的来源选项
      this.loadSourceOptions(this.selectedDomain);

      // 延迟一点时间再显示对话框，避免可能的事件冲突
      setTimeout(() => {
        this.showSourceDialog = true;
      }, 100);
    },

    // 加载来源选项
    loadSourceOptions(domain) {
      const dictName = domain === 'private'
          ? 'order_source_description_coach'
          : 'order_source_description_platform';

      // 使用正确封装的getDict方法获取字典数据
      getDict({ name: dictName }).then(res => {
        if (res.status === 200 && res.data) {
          this.sourceOptions = res.data || [];
          console.log('来源选项已加载:', this.sourceOptions);
        } else {
          this.sourceOptions = [];
          this.$toast.fail('获取来源选项失败');
        }
      }).catch(err => {
        console.error('获取来源选项错误:', err);
        this.sourceOptions = [];
        this.$toast.fail('获取来源选项失败');
      });
    },

    // 切换公域/私域标签
    switchDomain(domain) {
      this.selectedDomain = domain;
      this.selectedSources = []; // 清除已选择的来源
      this.hasOtherSelected = false; // 重置"其他"选项状态
      this.sourceRemark = ""; // 清空备注
      this.loadSourceOptions(domain);
    },

    // 选择来源
    toggleSource(option, e) {
      // 阻止事件冒泡，防止关闭对话框
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }

      console.log('选择来源被点击:', option.label);

      // 如果选项已禁用，则不处理
      if (this.hasOtherSelected && (option.value !== '3' && option.value !== '6')) {
        console.log('选项被禁用，无法选择');
        return;
      }

      // 判断是否已选择该选项
      const isSelected = this.selectedSources.some(item => item.id === option.id);
      console.log('选项当前选择状态:', isSelected ? '已选择' : '未选择');

      // 如果是"其他"选项
      if (option.value === '3'||option.value === '6') {
        if (isSelected) {
          // 取消选择"其他"选项
          this.selectedSources = this.selectedSources.filter(item => item.id !== option.id);
          this.hasOtherSelected = false;
          this.sourceRemark = ""; // 清空备注
        } else {
          // 选择"其他"选项，清除其他所有选择
          this.selectedSources = [option];
          this.hasOtherSelected = true;
          // 聚焦备注输入框
          this.$nextTick(() => {
            const input = document.querySelector('.remark-input input');
            if (input) input.focus();
          });
        }
      } else {
        // 普通选项
        if (isSelected) {
          // 取消选择
          this.selectedSources = this.selectedSources.filter(item => item.id !== option.id);
        } else {
          // 添加选择
          this.selectedSources.push(option);
        }
      }

      console.log('选择后的源列表:', this.selectedSources);
    },

    // 显示自定义提示框
    showCustomToast(message) {
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },

    // 确认来源选择
    confirmSourceSelection(e) {
      // 阻止事件冒泡
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }

      // 首先验证是否选择了来源
      if (this.selectedSources.length === 0) {
        this.showCustomToast('请选择订单来源');
        return;
      }

      // 如果选择了"其他"选项，则验证是否填写了备注
      if (this.hasOtherSelected && !this.sourceRemark.trim()) {
        this.showCustomToast('请输入其他来源内容');
        return;
      }

      const orderToProcess = this.currentOrder;
      const selectedDomain = this.selectedDomain;
      const selectedSources = this.selectedSources;

      // 获取所有选中选项的label，用逗号拼接
      let sourceLabels = selectedSources.map(item => item.label).join(',');

      // 如果有用户手动输入的备注（当选择"其他"时），加上这个备注
      const userRemark = this.sourceRemark.trim();
      if (this.hasOtherSelected && userRemark) {
        sourceLabels = sourceLabels + ":" + userRemark;
      }

      this.showSourceDialog = false; // 关闭对话框

      // 检查是否需要审核
      const needsReview = selectedDomain !== (orderToProcess.source === 1 ? 'private' : 'public');
      const apiSourceType = selectedDomain === 'private' ? 1 : 2;

      // 调用confirmOrder方法，传递回调函数
      setTimeout(() => {
        this.confirmOrder(orderToProcess, apiSourceType, null, sourceLabels);
      }, 50);
    },

    // 恢复confirmOrder方法，但使用opts回调方式实现
    confirmOrder(order, apiSourceType, sourceIds, sourceLabels) {
      this.$dialog.confirm({
        mes: '是否确认该订单？',  // 使用mes而不是message
        opts: () => {
          if (this.isSubmitting) return;
          this.isSubmitting = true;
          this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
          coachConfirmSource({
            uni: order.orderId,
            confirmOrderSource: apiSourceType,
            sourceRemark: sourceLabels
          }).then(() => {
            return submitOrderHandle({
              uni: order.orderId,
              confirmOrderSource: apiSourceType,
              sourceRemark: sourceLabels
            });
          }).then(() => {
            this.$toast.success("订单已确认！");
            this.sourceRemark = "";
            this.changeType(2);
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          }).finally(() => {
            this.isSubmitting = false;
          });
        }
      });
    },
    finishOrder(order) {
      let message =
          order.firstOrder == 1
              ? "请您确认：已经与教练完成了本次对话。"
              : "您已与教练完成3次约谈，确认后将会继续教练旅程，不再退款。";

      // 如果是公益教练
      if (order.welfareOrder == 1) {
        message = "您已与教练完成3次约谈，确认后将会继续教练旅程，不再退款。";
      }

      //  如果为单次订单 或者 单次并且为续约
      if (this.isSingle(order)) {
        message = "请您确认：已经与教练完成了本次对话。";
      }

      // 使用项目中正确的Dialog调用方式
      this.$dialog.confirm({
        mes: message,  // 使用mes而不是message
        opts: () => {
          // 用户点击确认按钮的回调
          finishOrderHandle({ uni: order.orderId }).then((res) => {
            this.changeType(3);
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          });
        }
      });
    },
    coachOrder(order) {
      let message =
          order.firstOrder == 1
              ? "请您确认：已经与客户完成了教练对话。"
              : "请您确认:您已经与客户达成一致，继续整个教练服务旅程(教练3次后确认)。";

      // 如果是公益教练
      if (order.welfareOrder == 1) {
        message =
            "请您确认:您已经与客户达成一致，继续整个教练服务旅程(教练3次后确认)。";
      }

      //  如果为单次订单 或者 单次并且为续约
      if (order.cartInfo && order.cartInfo.length > 0) {
        const productInfo = order.cartInfo[0];
        if (this.isSingle(order)) {
          message = "请您确认：已经与客户完成了教练对话。";
        }
      }

      // 使用项目中正确的Dialog调用方式
      this.$dialog.confirm({
        mes: message,  // 使用mes而不是message
        opts: () => {
          // 用户点击确认按钮的回调
          coachOrderHandle({ uni: order.orderId }).then((res) => {
            this.changeType(this.$route.params.type);
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          });
        }
      });
    },
    inviteEvaluation(order) {
      // 准备需要传递的参数
      const params = new URLSearchParams();

      // 订单基本信息
      params.append('orderId', order.orderId);
      // 添加来源参数
      params.append('from', 'invitation');

      // 套餐信息
      if (order.cartInfo && order.cartInfo[0] && order.cartInfo[0].productInfo) {
        const productInfo = order.cartInfo[0].productInfo;
        params.append('storeName', productInfo.storeName || '');

        if (productInfo.attrInfo) {
          params.append('skuName', productInfo.attrInfo.skuName || '');
          params.append('sku', productInfo.attrInfo.sku || '');
          params.append('price', productInfo.attrInfo.price || '');
        }
        if (productInfo.attrInfo==null) {//如果是单次套餐attrInfo是==null的
          params.append('skuName','单次套餐');
          params.append('sku','1');
          params.append('price', productInfo.price || '');
        }
      }

      // 教练信息
      if (order.coailUser) {
        params.append('coachName', order.coailUser.realName || '');
        params.append('coachPhone', order.coailUser.phone || '');
        params.append('coachUid', order.coailUser.uid || '');
      }

      // 用户信息
      if (order.lcUser) {
        params.append('userUid', order.lcUser.uid || '');
        params.append('userName', order.lcUser.realName || '');
        params.append('userPhone', order.lcUser.phone || '');
      }

      // 原有评价链接
      const baseEvalLink = `${window.location.origin}/goods_evaluate/${order.cartInfo[0].unique}`;
      // 完整评价链接
      const evalLink = `${baseEvalLink}?${params.toString()}`;

      this.$dialog.confirm({
        mes: "复制链接邀请客户评价",
        confirmButtonText: '复制链接',
        cancelButtonText: '取消',
        opts: () => {
          // 复制链接到剪贴板
          const input = document.createElement('input');
          input.value = evalLink;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);

          // 显示复制成功提示
          this.$toast.success({message:"您已复制评论链接，请直接粘贴发给客户",duration: 3000});

          // 保留原有的invite_evaluation接口调用
          inviteEvaluation({
            orderId: order.orderId
          }).then(res => {
            console.log("邀请评价通知发送成功");
          }).catch(err => {
            console.error("邀请评价通知发送失败", err);
          });
        }
      });
    },
    // 新增：当订单在审核中时，点击按钮显示提示
    showAuditPendingMessage() {
      this.$toast.info("该订单来源正在审核中，请耐心等待。");
    },
    cellOrder() {
      // 使用正确的Dialog调用方式
      this.$dialog.confirm({
        mes: "订单一旦终止，系统会默认发起退费申请。是否确认提前终止？", // 使用mes而不是message
        opts: () => {
          // 点击确认按钮的回调
          postOrderRefund({
            uni: this.orderInfo.orderId,
            text: "教练结束旅程并退款",
            userCategory: 2,
          })
              .then((res) => {
                this.$dialog.success(res.msg);
                this.getDetail();
              })
              .catch((e) => {
                this.$dialog.error(e.msg);
              });
        }
      });
    },
    // 新增：获取系统配置
    getSystemConfig: function() {
      // 使用项目中已配置的request模块发送请求
      request.get("/api/lcSystemConfig", {
        size: 1000
      }).then(data => {
        console.log("系统配置数据:", data);
        if (data && data.data && data.data.content) {
          // 获取订单来源说明配置
          const sourceConfig = data.data.content.find(item => item.id === 293);
          if (sourceConfig) {
            this.orderSourceDescription = sourceConfig.value;
          }

          // 获取基础URL配置 - 查找域名配置项
          const urlConfig = data.data.content.find(item =>
              item.key === "base_url" || item.key === "domain" || item.key === "base_domain"
          );

          if (urlConfig && urlConfig.value) {
            // 设置基础URL，确保格式正确
            let baseUrl = urlConfig.value;
            if (!baseUrl.startsWith("http")) {
              baseUrl = "https://" + baseUrl;
            }
            // 移除结尾的斜杠
            if (baseUrl.endsWith("/")) {
              baseUrl = baseUrl.slice(0, -1);
            }
            this.baseUrl = baseUrl;
            console.log("设置动态基础URL:", this.baseUrl);
          } else {
            // 如果找不到特定配置，尝试从当前窗口获取
            this.baseUrl = window.location.origin;
            console.log("使用当前窗口源作为基础URL:", this.baseUrl);
          }
        }
      }).catch(error => {
        console.error('获取系统配置失败', error);
        // 发生错误时使用当前窗口的origin
        this.baseUrl = window.location.origin;
        console.log("使用当前窗口源作为基础URL:", this.baseUrl);

        // 默认订单来源说明
        this.orderSourceDescription = "请选择订单来源，公域来源为平台引流或平台推广获得的客户，私域来源为线下转介绍与教练和其本人直接接触而来的客户。";
      });
    },
    // 新增删除订单方法
    deleteOrder(order,userCategory) {
      this.$dialog.confirm({
        mes: '确定要删除此订单吗？删除后将无法恢复', // 使用mes而不是message
        opts: () => {
          // 用户点击确认按钮的回调
          delClient(order.orderId,userCategory).then(() => {
            this.$toast.success('删除成功');
            // 从列表中移除已删除的订单
            this.orderList = this.orderList.filter(item => item.orderId !== order.orderId);
          }).catch(err => {
            this.$toast.fail(err.msg || '删除失败');
          });
        }
      });
    },
    // 新增方法：去评价页面并传递参数
    goToEvaluate(order) {
      // 准备需要传递的参数
      const params = new URLSearchParams();

      // 订单基本信息
      params.append('orderId', order.orderId);

      // 套餐信息
      if (order.cartInfo && order.cartInfo[0] && order.cartInfo[0].productInfo) {
        const productInfo = order.cartInfo[0].productInfo;
        params.append('storeName', productInfo.storeName || '');

        if (productInfo.attrInfo) {
          params.append('skuName', productInfo.attrInfo.skuName || '');
          params.append('sku', productInfo.attrInfo.sku || '');
          params.append('price', productInfo.attrInfo.price || '');
        }
        if (productInfo.attrInfo==null) {//如果是单次套餐attrInfo是==null的
          params.append('skuName','单次套餐');
          params.append('sku','1');
          params.append('price', productInfo.price || '');
        }
      }

      // 教练信息
      if (order.coailUser) {
        params.append('coachName', order.coailUser.realName || '');
        params.append('coachPhone', order.coailUser.phone || '');
        params.append('coachUid', order.coailUser.uid || '');
      }

      // 用户信息
      if (order.lcUser) {
        params.append('userUid', order.lcUser.uid || '');
        params.append('userName', order.lcUser.realName || '');
        params.append('userPhone', order.lcUser.phone || '');
      }

      // 构建评价链接
      const evalLink = `/goods_evaluate/${order.cartInfo[0].unique}?${params.toString()}`;

      // 跳转到评价页面
      this.$router.push(evalLink);
    },
    // 新增：复制订单链接
    copyOrderLink(orderId,type) {
      const userCategory = this.userCategory;
      let link='';//初始化链接
      if (type==1) {
         link = `${this.baseUrl}/order/list?userCategory=1&orderId=${orderId}`;
      }if (type==2) {
         link = orderId;//只复制订单号
      }
      //控制台输出type
      console.log("复制链接的类型:", type, "链接内容:", link);

      // 复制链接到剪贴板
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      if (type==1) {
      // 显示复制成功提示
      this.$toast.success({message:"订单链接已复制到剪贴板，可以直接粘贴发送给客户",duration: 3000});
      }
      if (type==2) {
        // 显示复制成功提示
        this.$toast.success({message:"订单号已复制到剪贴板",duration: 3000});
      }
    },
  },
  mounted() {
    this.getOrderList();
    this.getAgree();
    this.getSystemConfig(); // 新增：获取订单来源说明
    // 设置已读
    this.setOrderRead();

    // 从查询参数恢复筛选状态
    if (this.$route.query.filterIndex !== undefined) {
      this.activeFilterIndex = parseInt(this.$route.query.filterIndex);
    }

    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
    // 添加点击空白区域关闭下拉菜单的事件监听
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.closeDropdown);
  },
};
</script>

<style scoped>
/* 新增下拉菜单样式 */
.order-filter {
  background: #fff;
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 0.1rem;
  position: relative;
  z-index: 10;
}

.dropdown-filter {
  position: relative;
}

.selected-filter {
  display: flex;
  align-items: center;
  padding: 0.1rem 0;
  font-size: 0.3rem;
  color: #333;
  font-weight: bold;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.2rem;
  border-left: 0.15rem solid transparent;
  border-right: 0.15rem solid transparent;
  border-top: 0.15rem solid #666;
  transition: transform 0.3s;
}

.arrow-up {
  transform: rotate(-180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 0.1rem;
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 70vh;
  overflow-y: auto;
}

.dropdown-item {
  padding: 0.2rem 0.3rem;
  font-size: 0.28rem;
  color: #333;
  transition: background-color 0.3s;
}

.dropdown-item:active {
  background-color: #f5f5f5;
}

.dropdown-item.active {
  color: #0ce6df;
  font-weight: bold;
  position: relative;
}

.dropdown-item.active::after {
  content: '';
  position: absolute;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.4rem;
  height: 0.04rem;
  background-color: #0ce6df;
}

.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}

.order-status {
  position: absolute;
  color: #ff5500;
  right: -0.1rem;
  top: 0.5rem;
  width: 2rem;
  text-align: center;
  transform: rotateZ(45deg) scale(1);
  font-size: 0.26rem;
  padding: 0.1rem 0;
  border-bottom: 1px solid #ff5500;
  border-top: 1px solid #ff5500;
}

.order-top {
  padding: 0.2rem 0.3rem 0;
}

.agree-content {
  width: 80vw;
  min-height: 20vh;
  max-height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0.3rem;
}

.agree-title {
  padding: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.agree-btn {
  display: block;
  color: #fff;
  height: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
  border-radius: 0.5rem;
  margin: 0.3rem;
}

.line1 {
  font-size: 0.25rem;
}

.totalPrice .commission {
  color: #FF9500;
  font-size: 100%;
  margin-left: 0.1rem;
  display: inline;
}

/* 新增：禁用按钮的样式 */
.btn-disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

/* 来源选择对话框样式 */
.source-select-container {
  padding: 15px 15px 20px;
  position: relative;
  max-height: 88vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.source-select-header {
  text-align: center;
  font-size: 18px;
  margin: 5px 0 20px;
  font-weight: bold;
  padding-top: 15px;
}

.domain-tabs {
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  border: 1px solid #eee;
}

.domain-tab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  background-color: #f8f8f8;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.domain-tab.active {
  background-color: #0ce6df;
  color: white;
}

.source-options {
  margin-bottom: 20px;
}

.source-option {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  z-index: 10;
  margin-bottom: 8px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.source-option:active {
  background-color: rgba(0, 0, 0, 0.05);
}

.source-option.selected {
  background-color: rgba(12, 230, 223, 0.1);
}

.source-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.source-checkbox {
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.source-option.selected .source-checkbox {
  border-color: #0ce6df;
  background-color: #0ce6df;
}

.checkbox-inner {
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -2px;
}

.source-label {
  font-size: 14px;
  color: #333;
}

.source-note {
  padding: 10px 0;
  line-height: 1.4;
  font-size: 12px;
  color: #999;
}

.remark-input {
  margin: 15px 0;
}

.remark-input input {
  width: 100%;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
}

.confirm-button {
  width: 100%;
  background-color: #0ce6df;
  color: white;
  text-align: center;
  padding: 12px 0;
  border-radius: 25px;
  font-size: 16px;
  margin: 20px auto 10px;
  cursor: pointer;
  display: block;
  box-shadow: 0 2px 8px rgba(12, 230, 223, 0.3);
  font-weight: bold;
  max-width: 90%;
  position: relative;
  z-index: 10;
}

.confirm-button:active {
  background-color: #0ad5cf;
}

/* 确保来源选择对话框内的内容正常显示 */
.source-select-dialog {
  z-index: 2500 !important; /* 确保足够高 */
}

.source-select-dialog :deep(.van-overlay) {
  z-index: 2499 !important;
}

.source-select-dialog :deep(.van-dialog) {
  overflow: visible !important;
  border-radius: 12px;
  width: 92% !important;
  max-width: 340px;
  margin: 0 auto;
  z-index: 2500 !important;
}

.source-select-dialog :deep(.van-dialog__content) {
  position: relative;
  z-index: 2002;
}

:deep(.van-dialog__header) {
  padding-top: 20px;
  font-weight: bold;
}

/* 确保Dialog按钮可见 */
:deep(.van-dialog__footer) {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

:deep(.van-button) {
  flex: 1;
  height: 44px;
  font-size: 16px;
}

:deep(.van-dialog__confirm) {
  color: #0ce6df;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2010;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.02);
}

.close-icon:active {
  background-color: rgba(0, 0, 0, 0.1);
}

.close-icon i {
  font-size: 18px;
  color: #666;
}

/* 新增删除按钮样式 */
.delete-btn {
  background-color: #ff6b6b;
  color: white;
  border-radius: 0.04rem;
  padding: 0 0.2rem;
  height: 0.5rem;
  line-height: 0.5rem;
}

/* 待付款状态下的删除按钮样式 */
.acea-row .delete-btn {
  margin-left: 0.1rem;
}

/* 已退款状态下的删除按钮样式 */
.refund-actions .delete-btn {
  margin-right: 0.3rem;
}

/* 已退款状态的操作区域样式 */
.refund-actions {
  display: flex;
  align-items: center;
}

.refund-actions > div:last-child {
  color: #666;
}

.source-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.source-option.selected {
  background-color: rgba(12, 230, 223, 0.05);
}

.confirm-button {
  width: 100%;
  background-color: #0ce6df;
  color: white;
  text-align: center;
  padding: 12px 0;
  border-radius: 25px;
  font-size: 16px;
  margin: 20px auto 10px;
  cursor: pointer;
  display: block;
  box-shadow: 0 2px 8px rgba(12, 230, 223, 0.3);
  font-weight: bold;
  max-width: 90%;
  position: relative;
  z-index: 10;
}

.confirm-button:active {
  background-color: #0ad5cf;
}

.source-select-dialog .close-icon {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2010;
  border-radius: 50%;
}

.source-select-dialog .close-icon:active {
  background-color: rgba(0, 0, 0, 0.05);
}

.source-select-dialog .close-icon i {
  font-size: 18px;
  color: #999;
}

.source-dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2010;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.02);
}

.source-dialog-close:active {
  background-color: rgba(0, 0, 0, 0.1);
}

.source-dialog-close i {
  font-size: 18px;
  color: #666;
}

/* 订单链接按钮样式 */
.order-link-btn {
  position: absolute;
  top: 1.3rem;
  right: 65px;
  padding: 0.05rem 0.15rem;
  background-color: #0ce6df;
  color: #032e2c;
  border-radius: 0.2rem;
  font-size: 0.24rem;
  cursor: pointer;
  z-index:  0;
  box-shadow: 0 1px 3px rgba(12, 230, 223, 0.3);
}

.order-link-btn:active {
  background-color: #0ad5cf;
}

/* 添加复制图标样式 */
.copy-icon {
  display: inline-block;
  margin-left: 0.15rem;
  color: #0ce6df;
  font-size: 0.32rem;
  vertical-align: middle;
  cursor: pointer;
}
.copy-icon:active {
  opacity: 0.8;
}

/* 自定义提示框样式 */
.custom-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 100000;
  text-align: center;
  max-width: 80%;
  word-break: break-word;
}

/* 确保提示框显示在最顶层 */
.van-toast {
  z-index: 9999 !important;
}
</style>

